export const hasUndefinedElement = (filterArray: (string | undefined)[]) => {
  return filterArray.some(element => element !== undefined);
};
